import React from "react";
import ChartWrapper from "../../../Pages/ApplicationBlock/ChartRenderer/ChartWrapper";
import { gridCommonFunction } from "./utils/gridCommonFunction";

const ChartPreview = ({ data }) => {
  let chartArray = data.config.charts;

  let rowItemElements = [];
  let LayoutArray = [];
  for (let index = 0; index < chartArray.length; index++) {
    let gridElement = chartArray[index];
    LayoutArray.push(gridElement.grid);
    rowItemElements.push(gridElement.element_config);
  }
  let styleDataForGrid = gridCommonFunction.convertArrayInGridTemplateAreas(LayoutArray);

  return (
    <div className="page_main_section h_100">
      <div style={styleDataForGrid}>
        {rowItemElements.map((colItem, colItemIndexIs) => {
          let styleObject = {
            gridArea: `zino-${colItem.i || colItem.id}`
          };

          return (
            <div key={colItem.id + colItemIndexIs} style={styleObject}>
              {colItem.chart_type === "table" ? (
                <div>
                  <div>
                    <h1>{colItem.title}</h1>
                  </div>
                  <div className="user_table">
                    <table>
                      <thead>
                        <tr>
                          <th>{colItem.xaxis_title}</th>
                          <th>{colItem.yaxis_title}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                        <tr>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                // <Chart chartConfig={colItem} />
                <ChartWrapper chartConfig={colItem} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChartPreview;
